import React, { useRef, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as Takephoto } from "../../../Assets/img/Kyc/svg/Takephoto.svg";
import {
  Box,
  Button,
  Dialog,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as Verify } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as NonVerify } from "../../../Assets/img/icons/Verified-icon-new.svg";
import "../../../Assets/css/kyc.css";
import { ReactComponent as Successmsg } from "../../../Assets/img/Kyc/svg/successmsg.svg";
import { useNavigate } from "react-router-dom";

const VerifyVisa = () => {
  const navigate = useNavigate();
  const numOfContainers = 6;
  // const [open, setOpen] = useState(false);
  const [issueDate, setIssueDate] = useState("");
  const [passPortNumber, setPassPortNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [visaType, setVisaType] = useState("");
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [showData, setShowData] = useState(true);
  const [visaNumber, setVisaNumber] = useState("");
  const [masking, setMasking] = useState();
  const inputRefs = useRef([]); // Create an array of refs for each text field
  const [verify, setVerify] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true); // Set dragging state
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files; // Access dropped files
    handleFileChange({ target: { files } }); // Pass files to the handler
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Only handle one file
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target.result);
        // Set the image preview to the FileReader result
      };
      reader.readAsDataURL(file);
      console.log("Image preview", imagePreview);
      // Read the file as a data URL for preview
    } else {
      console.log("Please upload a valid image file.");
    }
  };

  const maskingFunction = (data) => {
    if (data <= 4) {
      return data;
    }
    return data.slice(-4).padStart(data.length, "*");
  };
  const handleMasking = (e) => {
    const input = e.target.value;
    setVisaNumber(input);
    const masking = maskingFunction(input);
    setMasking(masking);
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Validate input: check if it's a number
    if (/^\d$/.test(value)) {
      // If valid, move focus to the next field
      if (index < numOfContainers - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else {
      // If not valid, clear the input
      e.target.value = "";
    }
  };

  const handleClose = () => {
    // setOpen(false);
    setShowData(false);
    setVerifiedOpen(false);
  };

  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");

  // const handleFileChange = (event) => {
  //   const selectedFile = event.target.files[0];
  //   if (selectedFile) {
  //     setFile(selectedFile);
  //     const url = URL.createObjectURL(selectedFile); // Create a URL for the file
  //     setFileURL(url);
  //     console.log("Selected file:", selectedFile);
  //   }
  // };
  return (
    <>
      <div className="Allcards_full_container p-3">
        <div className=" rounded-2 bg-white p-2">
          <div className=" d-flex flex-column align-items-center justify-content-center m-4">
            <h2 className="m-0">Verify Your Visa Identity</h2>
            {showData ? (
              <p className="paragraph m-0">
                Upload Your Visa Details for Secure Verification
              </p>
            ) : (
              <p className="paragraph m-0">
                Your Visa Account has been Verified Successfully.
              </p>
            )}

            <div className="d-flex justify-content-center">
              <div>
                {!fileURL && (
                  <>
                    {imagePreview ? (
                      ""
                    ) : (
                      <>
                        <div
                          //   className={`file-upload-container ${
                          //     isDragging ? "dragging" : ""
                          //   }`}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <input
                            type="file"
                            accept="image/*,.pdf"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            id="file-input"
                          />

                          <label
                            htmlFor="file-input"
                            className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3"
                          >
                            <Cloud width={80} />
                            <span className="m-0 p-0">
                              {isDragging
                                ? "Drop file here"
                                : "Drag file here or "}
                              <span className="text-primary">Upload File</span>
                            </span>
                            <p>5MB max file size</p>
                          </label>
                        </div>
                      </>
                    )}

                    {imagePreview && (
                      <div className="selectedImage">
                        <img
                          src={imagePreview}
                          alt="Uploaded"
                          style={{ maxWidth: "300px", marginTop: "20px" }}
                        />
                      </div>
                    )}
                  </>
                )}

                {fileURL && (
                  <div className="selectedImage">
                    {file && file.type.startsWith("image/") && (
                      <img
                        src={fileURL}
                        alt="Selected"
                        style={{
                          marginTop: "10px",
                          // maxWidth: "300px",
                          // maxHeight: "300px",
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                    {file && file.type === "application/pdf" && (
                      <iframe
                        src={fileURL}
                        title="Selected PDF"
                        style={{
                          marginTop: "10px",
                          width: "100%",
                          height: "500px",
                        }}
                      />
                    )}
                  </div>
                )}
                {file && file.type === "application/pdf" && (
                  <iframe
                    src={fileURL}
                    title="Selected PDF"
                    style={{
                      marginTop: "10px",
                      width: "100%",
                      height: "500px",
                    }}
                  />
                )}
              </div>
              {!imagePreview && (
                <>
                  <Button className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3">
                    <Takephoto />
                    <p className="custom-text-color text-capitalize">
                      Capture Image
                    </p>
                  </Button>
                </>
              )}
            </div>

            {showData ? (
              <p className="paragraph">
                lease upload a clear image of your visa to begin the
                verification process. Our system will automatically detect{" "}
                <br />
                and display your visa details. Alternatively, you can manually
                enter the details below.
              </p>
            ) : (
              ""
            )}

            {!showData && (
              <div>
                <div className="d-flex flex-row align-items-center">
                  <TextField
                    value={masking}
                    onChange={setVisaNumber}
                    label={"Visa Number*"}
                    className="m-2"
                    style={{ width: "27vw" }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {verify ? <Verify /> : <NonVerify />}
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* <div className="verify d-flex align-items-center">
                {verify ? <Verify /> : <NonVerify />}
              </div> */}
                </div>

                <div className="d-flex flex-row align-items-center">
                  <TextField
                    value={passPortNumber}
                    onChange={(e) => setPassPortNumber(e.target.value)}
                    label={"Passport Number*"}
                    className="m-2"
                    style={{ width: "27vw" }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {verify ? <Verify /> : <NonVerify />}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* <div className="verify d-flex align-items-center">
                {verify ? <Verify /> : <NonVerify />}
              </div> */}
                </div>
              </div>
            )}

            {!showData ? (
              <p className="paragraph">
                Thank you for verifying your EPF account details. Your identity
                has been securely confirmed. You can now
                <br /> proceed to the next steps or return to your dashboard to
                explore other features.
              </p>
            ) : (
              ""
            )}

            {showData ? (
              <>
                <TextField
                  value={visaNumber}
                  onChange={handleMasking}
                  label={"Visa Number*"}
                  className="m-2"
                  style={{ width: "27vw" }}
                />
                <TextField
                  type="date"
                  value={issueDate}
                  onChange={(e) => setIssueDate(e.target.value)}
                  label={"Issue Date*"}
                  className="m-2"
                  style={{ width: "27vw" }}
                  InputLabelProps={{
                    shrink: true, // This forces the label to stay shrunk even when the field is empty
                  }}
                />

                <TextField
                  type="date"
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  label={"Expiry Date*"}
                  className="m-2"
                  style={{ width: "27vw" }}
                  InputLabelProps={{
                    shrink: true, // This forces the label to stay shrunk even when the field is empty
                  }}
                />
                <Box style={{ width: "27vw" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Type of Visa*
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={visaType}
                      label=" Type of Visa*"
                      onChange={(e) => setVisaType(e.target.value)}
                    >
                      <MenuItem value={10}>Tourist Visa</MenuItem>
                      <MenuItem value={20}>Business Visa</MenuItem>
                      <MenuItem value={30}>Student Visa</MenuItem>
                      <MenuItem value={40}>Work Visa</MenuItem>
                      <MenuItem value={50}>Medical Visa</MenuItem>
                      <MenuItem value={60}>Digital Nomad Visa</MenuItem>
                      <MenuItem value={70}>Retirement Visa</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <TextField
                  value={passPortNumber}
                  onChange={(e) => setPassPortNumber(e.target.value)}
                  label={"Passport Number*"}
                  className="m-2
              "
                  style={{ width: "27vw" }}
                />
              </>
            ) : (
              ""
            )}
            {showData ? (
              <>
                <div className="d-flex flex-row">
                  <Button
                    // variant="contained"
                    className="txtcolor m-3"
                    //   onClick={() => setOpen(true)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className="btncolor m-3"
                    onClick={() => setVerifiedOpen(true)}
                  >
                    Confirm
                  </Button>
                </div>
              </>
            ) : (
              <Button
                variant="contained"
                className="btncolor m-3"
                onClick={() => navigate("/countrySelecting")}
              >
                Back to KYC
              </Button>
            )}

            {/* <Dialog open={open} onClose={() => setOpen(true)}>
          <div className="m-4 justify-content-center align-items-center">
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              sx={{ margin: 2, padding: 0 }}
            >
              <div>
                <h6 className="m-0 p-0">Enter Your OTP</h6>
              </div>

              <div>
                <Close onClick={() => setOpen(false)} />
              </div>
            </div>
            <div>
              <div>
                <p className="m-0 p-0">
                  Verify Your Passport with the One-Time Password
                </p>

                <div className="d-flex flex-row m-5">
                  {Array.from({ length: numOfContainers }, (_, index) => (
                    <TextField
                      key={index}
                      inputRef={(el) => (inputRefs.current[index] = el)} // Assign ref to each text field
                      variant="standard"
                      style={{
                        margin: "10px",
                        width: "40px",
                        textAlign: "center",
                      }}
                      inputProps={{
                        maxLength: 1, // Only allow one character
                        style: { textAlign: "center" }, // Center text
                      }}
                      onChange={(e) => handleInputChange(e, index)} // Handle input change
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="m-3 d-flex justify-content-center">
            <Button
              variant="contained"
              onClick={() => {
                setVerifiedOpen(true);
                setOpen(false);
              }}
            >
              Verify
            </Button>
          </div>
        </Dialog> */}

            <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
              <div className=" my-2 mx-5 p-2 align-items-center justify-content-center text-center">
                <Successmsg />
                <div className="align-items-center justify-content-center text-center">
                  <h6 className="fw-bold">Verification Successful!</h6>
                  <p>Your Passport Details has been successfully verified.</p>
                </div>
                {/* <DialogContentText></DialogContentText> */}
              </div>
              <div className=" d-flex justify-content-center my-3">
                <Button
                  variant="contained"
                  className="btncolor"
                  onClick={() => handleClose()}
                >
                  continue
                </Button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyVisa;
